var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage25(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8964_36799)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1920 0H0V1080H1920V0Z",
    fill: "#FFF9EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.197 963.9H168.197V947.6H176.897V956.8H155.197V941.6H140.097V926.8H124.097V905.6H134.297V917.1H117.297V878.5",
    stroke: "#C11B19",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.194 943.102H131.594V951.702H140.194V943.102Z",
    stroke: "#C11B19",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.295 953.699H121.695V962.299H130.295V953.699Z",
    stroke: "#C11B19",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.694 953.699H141.094V962.299H149.694V953.699Z",
    stroke: "#C11B19",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.295 934.898H121.695V943.498H130.295V934.898Z",
    stroke: "#C11B19",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1737.9 926.799C1737.9 926.799 1752.9 921.899 1753.9 913.499L1725.6 912.399L1724.7 933.799C1724.5 937.699 1728.2 940.599 1732 939.499C1745.2 935.699 1771.4 925.399 1777.1 904.099L1717.5 901.699L1715.5 951.699C1715.5 951.699 1775.8 955.499 1790 894.699",
    stroke: "#FFAE48",
    strokeWidth: 3.96,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1695.1 925.2C1695.1 925.2 1680.6 919.1 1680.2 910.7L1708.5 911.8L1707.6 933.2C1707.4 937.1 1703.5 939.7 1699.8 938.3C1687 933.4 1661.7 921.1 1657.7 899.3L1717.3 901.7L1715.3 951.7C1715.3 951.7 1652.5 954 1647.9 889.5",
    stroke: "#FFAE48",
    strokeWidth: 3.96,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1698.7 837.102C1698.7 837.102 1683.7 842.002 1682.7 850.402L1711 851.502L1711.5 839.802C1711.9 830.902 1702.9 824.502 1694.6 827.802C1681.1 833.202 1664 843.002 1659.4 859.802L1719 862.202L1721 812.202C1721 812.202 1656.1 810.902 1647.6 869.302",
    stroke: "#FFAE48",
    strokeWidth: 3.96,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1741.4 838.802C1741.4 838.802 1755.9 844.902 1756.3 853.302L1728 852.202L1728.5 840.502C1728.9 831.602 1738.3 825.902 1746.3 829.902C1759.3 836.302 1775.6 847.601 1778.8 864.601L1719.2 862.202L1721.2 812.202C1721.2 812.202 1781 810.902 1789.2 870.002",
    stroke: "#FFAE48",
    strokeWidth: 3.96,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1653.6 865.203L1785.6 870.603C1788.7 870.803 1791.1 873.303 1791 876.403L1790.4 892.403C1790.2 895.503 1787.7 897.903 1784.6 897.803L1652.6 892.403C1649.5 892.203 1647.1 889.703 1647.2 886.603L1647.8 870.603C1647.9 867.403 1650.5 865.003 1653.6 865.203Z",
    stroke: "#FFAE48",
    strokeWidth: 3.96,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1661 873.301L1774.8 877.901C1775.9 878.001 1776.7 878.901 1776.7 880.001L1776.5 885.701C1776.4 886.801 1775.5 887.601 1774.4 887.601L1660.6 883.001C1659.5 882.901 1658.7 882.001 1658.7 880.901L1658.9 875.201C1658.9 874.201 1659.9 873.301 1661 873.301Z",
    stroke: "#FFAE48",
    strokeWidth: 3.96,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1705.5 935.002C1705.5 935.002 1688 955.902 1670.6 934.802C1670.6 934.802 1664.7 933.302 1663.8 930.202C1663.8 930.202 1664.8 929.302 1666.6 930.002C1666.6 930.002 1663.4 927.502 1664.4 926.402C1665.4 925.302 1668.6 928.002 1668.6 928.002C1668.6 928.002 1665.6 924.902 1667.5 924.502C1669.4 924.102 1671.3 928.202 1671.5 926.902C1671.7 925.602 1669.4 924.702 1671.2 924.602C1673 924.402 1674 926.902 1673.6 929.102C1673.6 929.102 1688.2 930.702 1695.1 921.402",
    fill: "#4E003D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1676 930.503C1676 930.503 1678.6 931.103 1682 930.203",
    stroke: "#870D45",
    strokeWidth: 0.88,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1682.3 932.202C1682.3 932.202 1684.4 931.902 1685.5 931.402",
    stroke: "#870D45",
    strokeWidth: 0.88,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1675.8 932.801C1675.8 932.801 1676.8 933.201 1678 933.001",
    stroke: "#870D45",
    strokeWidth: 0.88,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1679.3 934.902C1679.3 934.902 1679.9 935.002 1681.6 934.602",
    stroke: "#870D45",
    strokeWidth: 0.88,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1715.6 932.803C1715.6 932.803 1713.4 943.403 1716.6 949.903C1719.8 956.503 1726.2 953.503 1726.2 953.503C1726.2 953.503 1723.5 961.603 1729.5 960.303C1735.4 959.003 1734 949.503 1734 949.503C1734 949.503 1740.8 933.603 1732.6 924.203",
    fill: "#4E003D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1727.7 957.004C1727.7 957.004 1726.9 959.104 1727.2 960.404",
    stroke: "#870D45",
    strokeWidth: 0.44,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1729.9 957.102C1729.9 957.102 1728.9 959.402 1729 960.602",
    stroke: "#870D45",
    strokeWidth: 0.44,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1743.9 920.801C1743.9 920.801 1774.7 918.101 1779.6 883.201C1782 866.201 1748.7 851.001 1756.9 822.501C1765.1 793.901 1807.2 795.501 1804.8 812.001C1803.3 822.201 1764.4 815.401 1767.6 829.701C1770.8 844.001 1803.8 873.801 1789.9 901.601C1775.9 929.501 1746.3 932.101 1746.3 932.101",
    fill: "#4E003D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1757.7 919.602C1757.7 919.602 1763.1 916.602 1764.3 915.602",
    stroke: "#870D45",
    strokeWidth: 0.88,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1768.2 912.701L1770.9 909.801",
    stroke: "#870D45",
    strokeWidth: 0.88,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1765.9 917.302L1769 914.602",
    stroke: "#870D45",
    strokeWidth: 0.88,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1774 909.102L1776.2 904.602",
    stroke: "#870D45",
    strokeWidth: 0.88,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1759.9 922.002L1762.9 919.902",
    stroke: "#870D45",
    strokeWidth: 0.88,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1772.6 912.9L1774.7 911",
    stroke: "#870D45",
    strokeWidth: 0.88,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1780 903.502L1781.4 900.902",
    stroke: "#870D45",
    strokeWidth: 0.88,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1758.7 824.8C1758.7 824.8 1762.7 814.5 1766.5 812",
    stroke: "#870D45",
    strokeWidth: 0.88,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1771.8 807.802C1771.8 807.802 1774.2 806.102 1776.3 805.602",
    stroke: "#870D45",
    strokeWidth: 0.88,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1769.1 813.099C1769.1 813.099 1771.7 810.399 1772.9 809.699",
    stroke: "#870D45",
    strokeWidth: 0.88,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1758.1 829.5C1758.1 829.5 1757.5 831.9 1757.9 834.2",
    stroke: "#870D45",
    strokeWidth: 0.88,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1760.6 827.102C1760.6 827.102 1760.4 829.902 1760.4 831.302",
    stroke: "#870D45",
    strokeWidth: 0.88,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1759.1 838.199L1760.3 841.699",
    stroke: "#870D45",
    strokeWidth: 0.88,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1783.8 804.702C1783.8 804.702 1787.3 803.502 1790.7 803.802",
    stroke: "#870D45",
    strokeWidth: 0.88,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1778.6 808.8C1778.6 808.8 1782.4 807.6 1783 807.5",
    stroke: "#870D45",
    strokeWidth: 0.88,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1767.3 817L1763.7 821.3",
    stroke: "#870D45",
    strokeWidth: 0.88,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1795.9 804.602C1795.9 804.602 1799 805.302 1800 806.402",
    stroke: "#870D45",
    strokeWidth: 0.88,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1739.49 900.801C1739.49 900.801 1768.99 921.001 1742.29 941.801C1715.59 962.601 1666.49 936.901 1693.89 903.601L1739.49 900.801Z",
    fill: "#FF1B22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1748.49 914C1748.49 914 1750.79 916.2 1751.79 918.2",
    stroke: "#C11B19",
    strokeWidth: 0.66,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1748.99 918.5C1748.99 918.5 1749.99 920.6 1750.39 921.7",
    stroke: "#C11B19",
    strokeWidth: 0.66,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1687.89 924C1687.89 924 1687.39 925 1688.59 927.3",
    stroke: "#C11B19",
    strokeWidth: 0.66,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1689.09 930.801C1689.09 930.801 1689.29 933.001 1690.79 934.501",
    stroke: "#C11B19",
    strokeWidth: 0.66,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1690.3 928.102C1690.3 928.102 1690.5 930.702 1691.7 931.802",
    stroke: "#C11B19",
    strokeWidth: 0.66,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1693.4 936.402C1693.4 936.402 1694.1 938.402 1695.2 939.602",
    stroke: "#C11B19",
    strokeWidth: 0.66,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1695.8 934.301C1695.8 934.301 1697.1 937.601 1698.4 938.601",
    stroke: "#C11B19",
    strokeWidth: 0.66,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1747.09 868.899C1747.09 868.899 1750.99 831.599 1784.49 849.399C1817.99 867.199 1787.69 914.999 1751.49 897.599L1747.09 868.899Z",
    fill: "#FF1B22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1755.99 871.2C1755.99 871.2 1762.69 845.7 1779.99 859.2C1793.59 869.8 1791.39 893.1 1758.09 891.6L1755.99 871.2Z",
    fill: "#FF802C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1778.6 857.298C1778.6 857.298 1762 849.298 1759.2 865.898",
    stroke: "#4E003D",
    strokeWidth: 1.1,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1685.1 868.899C1685.1 868.899 1681.2 831.599 1647.7 849.399C1614.3 867.199 1644.5 914.999 1680.7 897.599L1685.1 868.899Z",
    fill: "#FF1B22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1676.1 871.2C1676.1 871.2 1669.4 845.7 1652.1 859.2C1638.5 869.8 1640.7 893.1 1674 891.6L1676.1 871.2Z",
    fill: "#FF802C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1644.9 868.001C1644.9 868.001 1657.5 843.901 1672.5 862.201",
    stroke: "#4E003D",
    strokeWidth: 1.1,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1720.9 835.5C1701.3 834.1 1688.5 837.5 1680.8 843.8C1675.4 847.6 1671.8 852.6 1669.8 858.9C1667.9 863.9 1667.6 871.5 1667.6 871.5C1640.7 897.6 1677.2 923.3 1699.4 923.5L1716.7 923.7C1735.4 922.9 1755.1 914 1758.1 891.6L1758.5 891.7C1758.6 891.6 1771.5 839 1720.9 835.5Z",
    fill: "#FF1B22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1668.99 864.298C1668.99 864.298 1668.39 847.398 1689.59 839.398",
    stroke: "#4E003D",
    strokeWidth: 1.1,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1687.5 883.399C1687.5 883.399 1666.4 870.799 1679.4 855.199C1692.4 839.499 1708.7 849.299 1712 857.999C1712 857.999 1723.3 842.399 1737.8 851.099C1752.3 859.799 1745.1 880.899 1726.8 882.799C1726.8 882.799 1739.3 910.299 1707.6 909.299C1675.9 908.299 1687.5 883.399 1687.5 883.399Z",
    fill: "#FF802C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1721.3 845.1C1721.3 845.1 1723.9 841 1728.3 842.2C1732.1 843.2 1732.8 846 1732.8 846",
    stroke: "#4E003D",
    strokeWidth: 1.1,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1692.8 843.6C1692.8 843.6 1695.4 839.5 1699.8 840.7C1703.6 841.7 1704.3 844.5 1704.3 844.5",
    stroke: "#4E003D",
    strokeWidth: 1.1,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1705.59 835.5C1705.59 835.5 1726.29 833 1740.59 840.4",
    stroke: "#4E003D",
    strokeWidth: 0.88,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1732.59 920.3C1769.99 907.1 1758.99 864.6 1758.99 864.6C1758.99 864.6 1757.59 858.2 1755.19 856",
    stroke: "#4E003D",
    strokeWidth: 1.1,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1668.59 871.5C1668.59 871.5 1653.19 880.8 1660.19 898.8C1667.69 918.5 1695.09 923 1695.09 923C1695.09 923 1709.79 924.1 1716.09 921.6",
    stroke: "#4E003D",
    strokeWidth: 1.1,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1692.79 851.499C1708.99 850.099 1709.59 883.999 1693.09 884.799C1677.49 885.599 1680.09 852.499 1692.79 851.499Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1698.39 858C1707.59 860 1705.09 882 1696.59 881.9C1686.59 882 1688.89 856 1698.39 858Z",
    fill: "#4E003D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1724.4 852.899C1729.4 852.499 1733 855.499 1735 859.799C1739.6 869.599 1736.3 886.199 1724.8 886.799C1708.1 887.599 1710.8 853.999 1724.4 852.899Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1722.7 858.797C1732.1 860.897 1729.5 883.397 1720.9 883.397C1710.7 883.397 1713.1 856.697 1722.7 858.797Z",
    fill: "#4E003D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1719.2 891.201C1719.2 891.201 1731.4 868.101 1748.6 881.401L1719.2 891.201Z",
    fill: "#FF1B22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1726.9 882.898C1732.1 882.298 1736.4 880.298 1739.6 877.298C1727.3 875.898 1719.3 891.098 1719.3 891.098L1728.6 887.998C1727.8 884.998 1726.9 882.898 1726.9 882.898Z",
    fill: "#FF802C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1736.7 880.699C1746.3 884.299 1740.4 898.799 1730.5 894.999C1720.6 891.199 1725.9 876.699 1736.7 880.699Z",
    fill: "#C11B19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1717.7 893.099C1717.7 893.099 1732 866.399 1748.7 881.299",
    stroke: "#4E003D",
    strokeWidth: 1.1,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1675.9 876.801C1676.4 876.801 1693.1 876.601 1694.6 893.401L1675.9 876.801Z",
    fill: "#FF1B22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1694.7 893.399C1693.7 881.999 1685.5 878.399 1680.3 877.199C1683.7 880.999 1687.6 883.399 1687.6 883.399C1687.6 883.399 1687.1 884.399 1686.6 886.199L1694.7 893.399Z",
    fill: "#FF802C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1675.9 876.801C1676.4 876.801 1693.1 876.601 1694.6 893.401",
    stroke: "#4E003D",
    strokeWidth: 1.1,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1686.3 881.601C1695.1 887.901 1685.7 900.502 1676.5 893.802C1667.3 887.202 1676.3 874.401 1686.3 881.601Z",
    fill: "#C11B19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1706.9 873.4C1721.1 873.7 1727.6 891.3 1707.9 892.2C1688.3 893.2 1694.1 873.2 1706.9 873.4Z",
    fill: "#FFAE48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1706.2 880.899C1706.2 880.899 1705.3 887.699 1707.6 888.299C1709.8 888.899 1710.9 881.699 1710.9 881.699C1710.9 881.699 1708.8 883.499 1708.7 880.199C1708.7 880.399 1707.9 884.599 1706.2 880.899Z",
    fill: "#4E003D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1706.2 885.902C1706.4 887.102 1706.8 888.102 1707.6 888.402C1709 888.802 1710 886.002 1710.5 883.902C1708.2 883.602 1706.9 884.702 1706.2 885.902Z",
    fill: "#C11B19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1706.2 880.899C1706.2 880.899 1705.3 887.699 1707.6 888.299C1709.8 888.899 1710.9 881.699 1710.9 881.699C1710.9 881.699 1708.8 883.499 1708.7 880.199C1708.7 880.399 1707.9 884.599 1706.2 880.899Z",
    stroke: "#4E003D",
    strokeWidth: 0.66,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1706.89 874.502C1706.89 874.502 1711.89 874.002 1711.89 874.802C1711.89 875.602 1709.89 877.802 1708.59 877.402C1707.19 877.202 1704.89 874.502 1706.89 874.502Z",
    fill: "#4E003D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1705.89 878.702C1705.89 878.702 1705.99 881.502 1707.29 882.102C1708.59 882.702 1708.59 876.602 1708.59 876.602",
    stroke: "#4E003D",
    strokeWidth: 0.66,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1711.49 878.302C1711.49 878.302 1711.29 882.502 1709.79 882.502C1708.79 882.502 1708.59 877.402 1708.59 877.402",
    stroke: "#4E003D",
    strokeWidth: 0.66,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1704.79 876.504C1704.79 876.504 1707.39 879.204 1704.59 885.404",
    stroke: "#4E003D",
    strokeWidth: 0.88,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1713.1 876.402C1713.1 876.402 1709.2 878.602 1711.7 888.202",
    stroke: "#4E003D",
    strokeWidth: 0.88,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1734.7 929.799C1734.7 929.799 1732.5 940.399 1735.7 946.899C1738.9 953.499 1745.3 950.499 1745.3 950.499C1745.3 950.499 1742.6 958.599 1748.6 957.299C1754.5 955.999 1753.2 946.499 1753.2 946.499C1753.2 946.499 1760 930.599 1751.8 921.199",
    fill: "#FF1B22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1735.9 939.098C1735.9 939.098 1735.9 941.698 1736.5 943.298",
    stroke: "#C11B19",
    strokeWidth: 0.66,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1737.8 940.801C1737.8 940.801 1738 943.001 1738.8 944.001",
    stroke: "#C11B19",
    strokeWidth: 0.66,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1737.49 946.398C1737.49 946.398 1738.09 947.698 1739.39 948.398",
    stroke: "#C11B19",
    strokeWidth: 0.66,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1741.09 947.301C1741.09 947.301 1742.49 948.301 1743.29 948.201",
    stroke: "#C11B19",
    strokeWidth: 0.66,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1746.5 952.699C1746.5 952.699 1745.5 956.399 1746.4 957.399",
    stroke: "#4E003D",
    strokeWidth: 0.44,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1734.1 932.801C1734.1 932.801 1731.2 957.901 1748.1 949.501",
    stroke: "#4E003D",
    strokeWidth: 0.88,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1748.9 953C1748.9 953 1748.2 955.9 1748.7 957.3",
    stroke: "#4E003D",
    strokeWidth: 0.44,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1706.29 958.7C1706.29 958.7 1704.59 957.7 1702.89 957.7C1701.29 957.8 1704.29 952.9 1709.09 957.5L1706.29 958.7Z",
    fill: "#4E003D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1721.19 924.301C1721.19 924.301 1694.99 931.901 1707.29 956.301C1707.29 956.301 1703.19 958.501 1702.99 960.101C1702.99 960.101 1704.99 963.301 1707.89 958.701C1707.89 958.701 1704.89 963.701 1706.49 963.601C1709.29 963.301 1712.39 958.901 1712.39 958.901C1712.39 958.901 1710.89 963.401 1711.69 963.801C1713.59 964.701 1716.09 956.701 1713.99 956.201C1713.99 956.201 1718.19 941.801 1729.39 939.301",
    fill: "#FF1B22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1722.9 942.402C1722.9 942.402 1716.2 948.202 1713.7 955.902",
    stroke: "#4E003D",
    strokeWidth: 0.88,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1710.99 929.602C1710.99 929.602 1698.49 939.402 1707.29 956.202",
    stroke: "#4E003D",
    strokeWidth: 0.88,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1707.49 940.002C1707.49 940.002 1708.29 936.102 1709.49 935.102",
    stroke: "#C11B19",
    strokeWidth: 0.66,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1707.09 942.199C1707.09 942.199 1706.39 944.799 1706.59 946.099",
    stroke: "#C11B19",
    strokeWidth: 0.66,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1709.69 940.301C1709.69 940.301 1708.89 943.001 1708.89 944.101",
    stroke: "#C11B19",
    strokeWidth: 0.66,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1711.2 936.599L1713.1 933.699",
    stroke: "#C11B19",
    strokeWidth: 0.66,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1707.8 948.902C1707.8 948.902 1707.4 949.602 1707.7 951.302",
    stroke: "#C11B19",
    strokeWidth: 0.66,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8964_36799"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage25);
export default __webpack_public_path__ + "static/media/image25.7c0493b738b17a0b9057bf16a7d083a2.svg";
export { ForwardRef as ReactComponent };